const logOutPopup = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const popupWrapper = document.getElementById('logout-popup-wrapper');
        const popupClose   = document.getElementById('logout-popup-close');
        const popupCloseBtn= document.getElementById('logout-popup-close-btn');
        const body         = document.body;


        document.addEventListener('click', function (e) {
            const logoutBtn = e.target.closest('.woocommerce-MyAccount-navigation-link--customer-logout a');

            if (!logoutBtn) return;


            e.preventDefault();
            popupWrapper.style.display = 'flex';
            popupWrapper.classList.add('active');
            body.style.overflow = 'hidden';
        });


        popupClose?.addEventListener('click', () => {
            popupWrapper.style.display = 'none';
            popupWrapper.classList.remove('active');
            body.style.overflow = 'auto';
        });

        popupCloseBtn?.addEventListener('click', () => {
            popupWrapper.style.display = 'none';
            popupWrapper.classList.remove('active');
            body.style.overflow = 'auto';
        });
    });
};

export default logOutPopup;
